import React, { FC, memo } from 'react'

import { styled } from '@linaria/react'
import loadable from '@loadable/component'

import { zIndex } from 'components/designSystem/zIndex'
import { useIsIosVersionWithSvgAnimationIssues } from 'hooks/useIsIosVersionWithSvgAnimationIssues'

import heartsSvg from './assets/svg/heart-icons-like.svg'

export const LikeAnimation: FC = () => {
  const iosVersionWithSvgAnimationIssues =
    useIsIosVersionWithSvgAnimationIssues()

  if (iosVersionWithSvgAnimationIssues) {
    return (
      <Parent>
        <LikeAnimationLottieLoadable />
      </Parent>
    )
  }

  return (
    <Parent>
      <object
        type="image/svg+xml"
        data={heartsSvg}
        width={200}
        height={812}
        draggable={false}
        style={{ userSelect: 'none' }}
      />
    </Parent>
  )
}

export const LikeAnimationMemo = memo(LikeAnimation)

const LikeAnimationLottieLoadable = loadable(
  () => import('./LikeAnimationLottie')
)

const Parent = styled.div`
  display: flex;
  position: fixed;
  align-items: center;
  right: 0;
  top: 0;
  height: 100%;
  width: 200px;
  z-index: ${zIndex.mailruMenuBurger};
  pointer-events: none;
  touch-action: none;
`
